import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { FormBuilder, FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { RiberaDefaultBtn } from '@ribera-web/ribera-default-btn';
import { RiberaInputFormUi } from '@ribera-web/ribera-input-form-ui';

@Component({
  selector: 'lib-buy-rewards',
  imports: [RiberaDefaultBtn, CommonModule, FormsModule, ReactiveFormsModule, RiberaInputFormUi],
  templateUrl: './buy-rewards.html',
  styleUrl: './buy-rewards.scss',
})
export class BuyRewards{

  fb = inject(FormBuilder);

  listButons = [
    { label: 'Dolares', value: '7d' },
    { label: 'Soles', value: '30d' }
  ];

  selected = signal(0);

  selectedOption(index: number) {
    this.selected.set(index);
  }

  formRewards = this.fb.group({
    usds: ['', Validators.required],
    rewards: ['', Validators.required]
  });

  getControl(controlName: string) {
    return this.formRewards.get(controlName) as FormControl;
  }

  convetRewards() {
    const usdsValue = this.getControl('usds').value;
    if (usdsValue) {
      const rewardsValue = usdsValue * 10; // Ejemplo de conversión: 1 USD = 10 Rewards
      this.getControl('rewards').setValue(rewardsValue);
    } else {
      this.getControl('rewards').setValue('');
    }
  }

}
